/* eslint-disable react/require-default-props */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import { PROPS_LIST } from '../../constants/props';
import { COLORS } from '../../constants/styles';
import { COMMON, COMMUNITIES_COMMON } from '../../constants/strings';

import Icon from '../Icon';

import { isDesktop } from '../../utils/mobileHelpers';
import getTypeText from '../../utils/communities/getCommunityTypeText';
import getMembersText from '../../utils/communities/getMembersText';
import getCommunityAccessType from '../../utils/communities/getCommunityAccessType';

import styles from './index.styl';

const Title = ({
  totalUsers,
  name,
  organizationName,
  type,
  accessLevel,
  totalPosts,
  intl: { formatMessage },
}) => {
  const readOnly = getCommunityAccessType(accessLevel, formatMessage);

  return (
    <Fragment>
      {isDesktop() && (
        <Fragment>
          <div styleName="title__name">{name}</div>
          <div styleName="title__desc">
            {formatMessage(COMMON.from)} {organizationName}
          </div>
        </Fragment>
      )}
      <div styleName="title__sub">
        <div className="mr1">
          <Icon
            name="icon-private"
            size={12}
            className="mr1"
            style={{
              minWidth: 12,
              minHeight: 12,
              background: COLORS.grayBluish,
            }}
          />
          <span className="mr1">{`${getTypeText(type, formatMessage)},`}</span>
          <span>{readOnly}</span>
        </div>
        <div className="mr1">
          <Icon
            name="icon-members"
            size={12}
            className="mr1"
            style={{
              minWidth: 12,
              minHeight: 12,
              background: COLORS.grayBluish,
            }}
          />
          <span>{getMembersText(totalUsers, formatMessage)}</span>
        </div>
        <div>
          <Icon
            name="icon-posts"
            height="5%"
            width="5%"
            className="mr1"
            style={{ minWidth: 12, minHeight: 12 }}
          />
          <span>
            {totalPosts} {formatMessage(COMMUNITIES_COMMON.posts)}
          </span>
        </div>
      </div>
    </Fragment>
  );
};

Title.propTypes = {
  totalUsers: PropTypes.number,
  name: PropTypes.string,
  type: PropTypes.oneOf(PROPS_LIST.community.type),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  organizationName: PropTypes.string,
  accessLevel: PropTypes.string,
  totalPosts: PropTypes.number,
};

export default injectIntl(CSSModules(Title, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/Community/Title.jsx